import { createContext, useContext } from "react";

import type { FullComponent, MonitorCheckStatusComponent } from "../../common/openapi";

export type BoundaryComponent = FullComponent | MonitorCheckStatusComponent;

const ComponentBoundaryContext = createContext<undefined | BoundaryComponent>(undefined);

export const ComponentBoundaryContextProvider = ComponentBoundaryContext.Provider;

export const useComponentBoundary = (): undefined | BoundaryComponent => useContext(ComponentBoundaryContext);
